
import { useLocation } from 'react-router-dom';

import React, { useState,useEffect } from 'react';
import './SideBar.scss';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { getLogoName ,listenToEvent, removeListener } from '../../Helpers/utils';
const SideBar = ({ isOpen, toggleSidebar }) => {
  const [Logo, setLogo] = useState(getLogoName);
    const navigate = useNavigate();
  const [showClass, setShowClass] = useState('');
  const [userData, setUserData] = useState({});
  const location = useLocation();
  const setToggle = (data) => {
    setShowClass((prev) => (prev === data ? '' : data));
  };
console.log('render')
  // Effect to load user data initially and set up the listener for localStorage changes
  useEffect(() => {
    const loadUserData = () => {
      const data = JSON.parse(localStorage.getItem('userData'))?.data?.user;
      setUserData(data || {});


    };
    if (location.pathname == '/my-account') {
      setShowClass('');
  }
  console.log('renders')
    // Load initial user data
    loadUserData();

    // Set up the storage event listener
    const handleStorageChange = (e) => {
      loadUserData(); // Update user data when localStorage changes
      if (e.key === 'Logo') {  // Check if the logo was updated in localStorage
         // Update the logo when localStorage changes
      }
      console.log('asdadadasdasd')
    };

    // Add storage event listener
    window.addEventListener('storage', handleStorageChange);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [location.pathname]);

  useEffect(() => {


    // Add storage event listener
    const handleCustomEvent = (e) => {
      setLogo(getLogoName) // Get the event data from e.detail
    };

    listenToEvent('customEvent', handleCustomEvent); // Listen for the event

    // Cleanup the event listener when ComponentB is unmounted
    return () => {
      removeListener('customEvent', handleCustomEvent); // Remove the listener
    };
  }, []);




  return (
    <div className={`sidebar ${isOpen ? 'open' : 'close'}`}>
      <div className="logo-details">
      <Link to="/my-account" style={{textDecoration:'none'}}>
      <div className="logo-resize">


                    {isOpen ?  <img
                      src="/images/doctor-logo1.png"
                      style={{ height: "45px" }}
                      alt="Logo"
                    /> :  <img
                    src="/images/vetconnex-final.png"
                    style={{ height: "45px" }}
                    alt="Logo"
                  />  }

                    </div>
</Link>

      </div>
      <ul className="nav-links">


      <li onClick={() => setToggle('Dashboard')}>
          <div className={`icon-link ${showClass == 'Dashboard' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/Dashboard")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-line-chart'></i>
              <span className="link_name">Dashboard</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px '}}>
        <li className={`li-setting icon-link ${showClass == 'Dashboard' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Dashboard'); // Ensure the submodule stays open
            navigate("/Dashboard")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-line-chart'></i>
                <span className={`${showClass != 'Dashboard' ? "link_name1" : 'link_name2'}`}>Dashboard</span>
            </Link>
        </li>
    </ul>





        </li>






<li onClick={() => setToggle('quality-check')}>
    <div className={`icon-link ${showClass == 'quality-check' ? "icon-link1" : ''}`} onClick={() => {
        navigate("/quality-check")
    }}>
        <Link className="loginhere-link">
            {/* Use the same icon for both main and submodule */}
            <i className="fa fa-flask"></i>

            <span className="link_name">Finger Printing </span>
        </Link>
    </div>

    <ul className="sub-menu" style={{padding:'12px 12px '}}>
        <li className={`li-setting icon-link ${showClass == 'quality-check' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('quality-check'); // Ensure the submodule stays open
            navigate("/quality-check")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className="fa fa-flask"></i>


                <span className={`${showClass != 'quality-check' ? "link_name1" : 'link_name2'}`}>Finger Printing </span>
            </Link>
        </li>
    </ul>
</li>




        <li onClick={() => setToggle('Appointment')}>
    <div className={`icon-link ${showClass == 'Appointment' ? "icon-link1" : ''}`} onClick={() => {
        navigate("/appointments")
    }}>
        <Link className="loginhere-link" >
            {/* Use the same icon for both main and submodule */}
            <i className='bx bx-calendar'></i>
            <span className="link_name">Appointment</span>
        </Link>
    </div>

    <ul className="sub-menu" style={{padding:'12px 12px '}}>
        <li className={`li-setting icon-link ${showClass == 'Appointment' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Appointment'); // Ensure the submodule stays open
            navigate("/appointments")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-calendar'></i>
                <span className={`${showClass != 'Appointment' ? "link_name1" : 'link_name2'}`}>Appointment</span>
            </Link>
        </li>
    </ul>
</li>



<li onClick={() => setToggle('Event')}>
    <div className={`icon-link ${showClass == 'Event' ? "icon-link1" : ''}`} onClick={() => {
        navigate("/events")
    }}>
        <Link className="loginhere-link">
            {/* Use the same icon for both main and submodule */}
            <i className='bx bx-calendar-event'></i>
            <span className="link_name">Events</span>
        </Link>
    </div>
    <ul className="sub-menu" style={{padding:'12px 12px '}}>
    <li className={`li-setting icon-link ${showClass == 'Event' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
        e.stopPropagation();
        setShowClass('Event'); // Ensure the submodule stays open
        navigate("/events")
    }}>
        <Link className="loginhere-link" style={{padding: "0px 20px"}}>
            {/* Same icon for submodule */}
            <i className='bx bx-calendar-event'></i>
            <span className={`${showClass != 'Event' ? "link_name1" : 'link_name2'}`}>Events</span>
        </Link>
    </li>
</ul>
</li>
<li onClick={() => setToggle('PIN')}>
    <div className={`icon-link ${showClass == 'PIN' ? "icon-link1" : ''}`} onClick={() => {
        navigate("/generate-pin")
    }}>
        <Link className="loginhere-link">
            {/* Use the same icon for both main and submodule */}
            <i className='fa fa-lock'></i>
            <span className="link_name">PIN</span>
        </Link>
    </div>

    <ul className="sub-menu" style={{padding:'12px 12px '}}>
        <li className={`li-setting icon-link ${showClass == 'PIN' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('PIN'); // Ensure the submodule stays open
            navigate("/generate-pin")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='fa fa-lock'></i>
                <span className={`${showClass != 'PIN' ? "link_name1" : 'link_name2'}`}>PIN</span>
            </Link>
        </li>
    </ul>
</li>


<li onClick={() => setToggle('Patient')}>
    <div className={`icon-link ${showClass == 'Patient' ? "icon-link1" : ''}`} onClick={() => {
        navigate("/orders")
    }}>
        <Link className="loginhere-link">
            {/* Use the same icon for both main and submodule */}
            <i className='fa fa-clipboard-list'></i>
            <span className="link_name">Orders</span>
        </Link>
    </div>

    <ul className="sub-menu" style={{padding:'12px 12px '}}>
        <li className={`li-setting icon-link ${showClass == 'Patient' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Patient'); // Ensure the submodule stays open
            navigate("/orders")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='fa fa-clipboard-list'></i>
                <span className={`${showClass != 'Patient' ? "link_name1" : 'link_name2'}`}>Orders</span>
            </Link>
        </li>
    </ul>
</li>
<li onClick={() => setToggle('orders')}>
    <div className={`icon-link ${showClass == 'orders' ? "icon-link1" : ''}`} onClick={() => {
        navigate("/partners")
    }}>
        <Link className="loginhere-link">
            {/* Use the same icon for both main and submodule */}
            <i className='fa fa-handshake'></i>
            <span className="link_name">Partners</span>
        </Link>
    </div>
    <ul className="sub-menu" style={{padding:'12px 12px '}}>
    <li className={`li-setting icon-link ${showClass == 'orders' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
        e.stopPropagation();
        setShowClass('orders'); // Ensure the submodule stays open
        navigate("/partners")
    }}>
        <Link className="loginhere-link" style={{padding: "0px 20px"}}>
            {/* Same icon for submodule */}
            <i className='fa fa-handshake'></i>
            <span className={`${showClass != 'orders' ? "link_name1" : 'link_name2'}`}>Partners</span>
        </Link>
    </li>
</ul>
</li>


<li onClick={() => setToggle('product')}>
    <div className={`icon-link ${showClass == 'product' ? "icon-link1" : ''}`} onClick={() => {
        navigate("/products")
    }}>
        <Link className="loginhere-link">
            {/* Use the same icon for both main and submodule */}
            <i className='fa fa-box'></i>
            <span className="link_name">Products</span>
        </Link>
    </div>
    <ul className="sub-menu" style={{padding:'12px 12px '}}>
    <li className={`li-setting icon-link ${showClass == 'product' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
        e.stopPropagation();
        setShowClass('product'); // Ensure the submodule stays open
        navigate("/products")
    }}>
        <Link className="loginhere-link" style={{padding: "0px 20px"}}>
            {/* Same icon for submodule */}
            <i className='fa fa-box'></i>
            <span className={`${showClass != 'product' ? "link_name1" : 'link_name2'}`}>Products</span>
        </Link>
    </li>
</ul>
</li>








<li onClick={(e) =>
                  setToggle('user')// Ensure the user menu stays open
                } className={`${(showClass == 'user'|| showClass == 'user-manage' || showClass == 'manage-password' || showClass == 'Change Logo' ) ? "showMenu" : 'demo'}`}>
          <div className={`icon-link ${showClass == 'user' ? "icon-link1" : ''}`}>
            <Link className="loginhere-link" >
              <i className='bx bx-user'></i>
              <span className="link_name">Users</span>
            </Link>
            <i className='bx bxs-chevron-down arrow'></i>
          </div>
          <ul className="sub-menu">

             {userData.role == 'admin' && <li  className={`li-setting icon-link ${showClass == 'user-manage' ? "icon-link1" : ''}`} style={{padding:'9px'}}    onClick={(e) => {
               e.stopPropagation();
              setShowClass('user-manage');
      navigate("/user-management")}}><Link className="loginhere-link"  >
              <svg className={` me-3 bi bi-person-fill-gear me-3 ${showClass != 'user-manage' ? "link_name1" : 'link_name2'}`} xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" viewBox="0 0 16 16">
                <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
              </svg>
              <span  className={`${showClass != 'user-manage' ? "link_name1" : 'link_name2'}`}>Manage User</span>
              </Link></li>}
              <li className={`li-setting  icon-link ${showClass == 'manage-password' ? "icon-link1" : ''}`} style={{padding:'9px'}}  onClick={(e) => {
                  e.stopPropagation();
                setShowClass('manage-password');
      navigate("/change-password")}}><Link className="loginhere-link" >
              <svg className={` me-3 ${showClass != 'manage-password' ? "link_name1" : 'link_name2'}`} width="25" height="25" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier"strokeLinecap ="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Layer_2" data-name="Layer 2"> <g id="invisible_box" data-name="invisible box"> <rect width="48" height="48" fill="none"></rect> </g> <g id="Layer_7" data-name="Layer 7"> <path d="M39,18H35V13A11,11,0,0,0,24,2H22A11,11,0,0,0,11,13v5H7a2,2,0,0,0-2,2V44a2,2,0,0,0,2,2H39a2,2,0,0,0,2-2V20A2,2,0,0,0,39,18ZM15,13a7,7,0,0,1,7-7h2a7,7,0,0,1,7,7v5H15ZM14,35a3,3,0,1,1,3-3A2.9,2.9,0,0,1,14,35Zm9,0a3,3,0,1,1,3-3A2.9,2.9,0,0,1,23,35Zm9,0a3,3,0,1,1,3-3A2.9,2.9,0,0,1,32,35Z"></path> </g> </g> </g></svg>



              <span className={`${showClass != 'manage-password' ? "link_name1" : 'link_name2'}`}>Manage Password</span>
              </Link></li>






              {/* { userData.role == 'admin' &&<li className={`li-setting  icon-link ${showClass == 'Change Logo' ? "icon-link1" : ''}`} style={{padding:'9px'}}  onClick={(e) => {
                  e.stopPropagation();
                setShowClass('Change Logo');
      navigate("/change-logo")}}><Link className="loginhere-link" >
              <svg className={` me-3 bi bi-person-fill-gear ${showClass != 'Change Logo' ? "link_name1" : 'link_name2'}`} width="25" height="25" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier"strokeLinecap ="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Layer_2" data-name="Layer 2"> <g id="invisible_box" data-name="invisible box"> <rect width="48" height="48" fill="none"></rect> </g> <g id="Layer_7" data-name="Layer 7"> <path d="M39,18H35V13A11,11,0,0,0,24,2H22A11,11,0,0,0,11,13v5H7a2,2,0,0,0-2,2V44a2,2,0,0,0,2,2H39a2,2,0,0,0,2-2V20A2,2,0,0,0,39,18ZM15,13a7,7,0,0,1,7-7h2a7,7,0,0,1,7,7v5H15ZM14,35a3,3,0,1,1,3-3A2.9,2.9,0,0,1,14,35Zm9,0a3,3,0,1,1,3-3A2.9,2.9,0,0,1,23,35Zm9,0a3,3,0,1,1,3-3A2.9,2.9,0,0,1,32,35Z"></path> </g> </g> </g></svg>



              <span className={`${showClass != 'Change Logo' ? "link_name1" : 'link_name2'}`}>Change Logo </span>
              </Link></li>} */}
          </ul>
        </li>

{/*
        <li onClick={() => setToggle('service')} className={`${(showClass == 'service'|| showClass == 'otp') ? "showMenu" : 'demo'}`}>
          <div className={`icon-link ${showClass == 'service' ? "icon-link1" : ''}`} >
            <Link className="loginhere-link" >
              <i className='bx bx-bulb'></i>
              <span className="link_name">Services App</span>
            </Link>

            <i className='bx bxs-chevron-down arrow'></i>
          </div>
          <ul className="sub-menu">

            <li className={`li-setting icon-link ${showClass == 'otp' ? "icon-link1" : ''}`} style={{padding:'9px'}}  onClick={(e) => {
              e.stopPropagation(); // Prevent the click from bubbling up
              setShowClass('otp'); // Ensure the user menu stays open
      navigate("/generate-pin")}}><Link className="loginhere-link"  ><svg className={`me-3 ${showClass != 'otp' ? "link_name1" : 'link_name2'}`} fill="currentColor" width="25" height="25" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" ><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier"strokeLinecap ="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="OTP"> <path d="M458.4741,112H265V62.41A31.3815,31.3815,0,0,0,233.5879,31H62.4077A31.3806,31.3806,0,0,0,31,62.41V449.59A31.4379,31.4379,0,0,0,62.4077,481h171.18A31.4388,31.4388,0,0,0,265,449.59V292H458.4771A22.5231,22.5231,0,0,0,481,269.4771V134.5259A22.5257,22.5257,0,0,0,458.4741,112ZM125.5,50.08h45a11.25,11.25,0,0,1,0,22.5h-45a11.25,11.25,0,0,1,0-22.5Zm44.9956,411.7651h-45a11.25,11.25,0,1,1,0-22.5h45a11.25,11.25,0,0,1,0,22.5ZM245.1982,420.25H50.7974V91.75H245.1982V112H125.3149A22.3149,22.3149,0,0,0,103,134.3149V269.6641A22.3357,22.3357,0,0,0,125.3359,292H166v36.1489a11.1221,11.1221,0,0,0,18.9868,7.8643L229,292h16.1982Zm-24.39-210.06a11.3086,11.3086,0,0,1,4.14,15.39,11.198,11.198,0,0,1-15.39,4.14L195.25,221.44V238a11.25,11.25,0,0,1-22.5,0V221.44L158.437,229.72a11.198,11.198,0,0,1-15.39-4.14,11.3164,11.3164,0,0,1,4.14-15.39L161.5,202l-14.313-8.28a11.2689,11.2689,0,0,1,11.25-19.5293L172.75,182.47V166a11.25,11.25,0,0,1,22.5,0v16.47l14.3086-8.2793a11.2689,11.2689,0,0,1,11.25,19.5293L206.5,202Zm108,0a11.3086,11.3086,0,0,1,4.14,15.39,11.198,11.198,0,0,1-15.39,4.14L303.25,221.44V238a11.25,11.25,0,0,1-22.5,0V221.44L266.437,229.72a11.198,11.198,0,0,1-15.39-4.14,11.3164,11.3164,0,0,1,4.14-15.39L269.5,202l-14.313-8.28a11.2689,11.2689,0,0,1,11.25-19.5293L280.75,182.47V166a11.25,11.25,0,0,1,22.5,0v16.47l14.3086-8.2793a11.2689,11.2689,0,0,1,11.25,19.5293L314.5,202Zm108,0a11.3086,11.3086,0,0,1,4.14,15.39,11.198,11.198,0,0,1-15.39,4.14L411.25,221.44V238a11.25,11.25,0,0,1-22.5,0V221.44L374.437,229.72a11.198,11.198,0,0,1-15.39-4.14,11.3164,11.3164,0,0,1,4.14-15.39L377.5,202l-14.313-8.28a11.2689,11.2689,0,0,1,11.25-19.5293L388.75,182.47V166a11.25,11.25,0,0,1,22.5,0v16.47l14.3086-8.2793a11.2689,11.2689,0,0,1,11.25,19.5293L422.5,202Z"></path> </g> </g></svg> <span className={`${showClass != 'otp' ? "link_name1" : 'link_name2'}`}>PIN</span></Link ></li>

          </ul>
        </li> */}




      </ul>
    </div>
  );
};

export default SideBar;

